namespace GeniuzPOS.InitialData {
    export interface PsCashierForm {
        CashierId: Serenity.StringEditor;
        CashierName: Serenity.StringEditor;
        CashierLevel: Serenity.EnumEditor;
        CashierPassword: Serenity.PasswordEditor;
    }

    export class PsCashierForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCashier';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCashierForm.init)  {
                PsCashierForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.PasswordEditor;

                Q.initFormType(PsCashierForm, [
                    'CashierId', w0,
                    'CashierName', w0,
                    'CashierLevel', w1,
                    'CashierPassword', w2
                ]);
            }
        }
    }
}
